import nl from './nl';
import en from './en';
import de from './de';

const languages = { nl, en, de };

export function trans(key) {
	const lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
	return languages[lang]?.[key] ?? en[key] ?? key;
}

export default languages;